function escapeRegExp(text: string): string {
  return text.replaceAll(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/** Strip trailing `-copy-{n}` from basename so copies chain from the same root (e.g. `a-copy-2.png` → root `a`). */
export function extractCopyRootAndExtension(fileName: string): { root: string; extension: string } {
  const dot = fileName.lastIndexOf('.');
  const extension = dot >= 0 ? fileName.slice(dot) : '';
  const base = dot >= 0 ? fileName.slice(0, dot) : fileName;
  const copyMatch = /^(.+)-copy-(\d+)$/.exec(base);
  const root = copyMatch ? copyMatch[1] : base;
  return { root: root.slice(0, 120), extension };
}

export function nextCopyIndexedFileName(
  currentFileName: string,
  existingFileNames: readonly string[]
): string {
  const { root, extension } = extractCopyRootAndExtension(currentFileName);
  const pattern = new RegExp(`^${escapeRegExp(root)}-copy-(\\d+)${escapeRegExp(extension)}$`);
  let maxIndex = 0;
  for (const name of existingFileNames) {
    const match = pattern.exec(name);
    if (match) {
      maxIndex = Math.max(maxIndex, Number.parseInt(match[1], 10));
    }
  }
  return `${root}-copy-${maxIndex + 1}${extension}`;
}
